import {SUPPORTED_LANGUAGES} from './constants';
import {labels} from './translations';
import {getLangFromUrl} from './utils';
import {useGlobalization} from '@planday-corp/globalization';
import Helmet from 'react-helmet';

export const Headers = () => {
  const {i18n} = useGlobalization();
  const language = getLangFromUrl();

  return (
    <Helmet>
      <html lang={language} />
      <title>{i18n.t(labels.title)}</title>
      <meta name="robots" content="index,follow" />
      <meta name="description" content={i18n.t(labels.headerDescription)} />
      {SUPPORTED_LANGUAGES.map(lang => {
        const lowerCaseLang = lang.toLowerCase();
        return (
          <link
            key={lowerCaseLang}
            rel="alternate"
            hrefLang={lowerCaseLang}
            href={`${window.location.origin}/${lowerCaseLang}`}
          />
        );
      })}
      <meta property="og:title" content={i18n.t(labels.title)} />
      <meta
        property="og:description"
        content={i18n.t(labels.headerDescription)}
      />
      <meta property="og:url" content="https://signup.planday.com" />
      <link rel="icon" href="/favicon.ico" type="image/x-icon" />
    </Helmet>
  );
};
